<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
    <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
      <g stroke="#164194" stroke-width="2">
        <g>
          <g>
            <g>
              <g>
                <path d="M1 5.232L4.046 8.53 11 1" transform="translate(-187 -636) translate(128 476) translate(32 88) translate(0 51) translate(27 21)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>